var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkdin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 7.06641C14.6581 7.06641 15.9299 7.59319 16.8676 8.53087C17.8052 9.46855 18.332 10.7403 18.332 12.0664V17.8997H14.9987V12.0664C14.9987 11.6244 14.8231 11.2005 14.5105 10.8879C14.198 10.5753 13.7741 10.3997 13.332 10.3997C12.89 10.3997 12.4661 10.5753 12.1535 10.8879C11.841 11.2005 11.6654 11.6244 11.6654 12.0664V17.8997H8.33203V12.0664C8.33203 10.7403 8.85882 9.46855 9.7965 8.53087C10.7342 7.59319 12.0059 7.06641 13.332 7.06641Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0013 7.90039H1.66797V17.9004H5.0013V7.90039Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33464 5.39974C4.25511 5.39974 5.0013 4.65355 5.0013 3.73307C5.0013 2.8126 4.25511 2.06641 3.33464 2.06641C2.41416 2.06641 1.66797 2.8126 1.66797 3.73307C1.66797 4.65355 2.41416 5.39974 3.33464 5.39974Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.768af3a6864cda8fda5081290873cc90.svg";
export { ForwardRef as ReactComponent };